import { render, staticRenderFns } from "./CoursewareTile.vue?vue&type=template&id=f44765e0&"
import script from "./CoursewareTile.vue?vue&type=script&lang=js&"
export * from "./CoursewareTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports